import { render, staticRenderFns } from "./BrowserSelectorInline.vue?vue&type=template&id=84152db6"
import script from "./BrowserSelectorInline.vue?vue&type=script&lang=js"
export * from "./BrowserSelectorInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports